var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.827 19.166a9.083 9.083 0 119.083-9.083c0 2.1-.712 4.032-1.907 5.57l6.116 6.116-1.606 1.606-6.116-6.116a9.044 9.044 0 01-5.57 1.907zm6.812-9.083a6.812 6.812 0 11-13.624 0 6.812 6.812 0 0113.624 0z",
    fill: "#22242C"
  })));
}
export default __webpack_public_path__ + "media/icons/search-e84f25d9.svg";
export { SvgSearch as ReactComponent };